export default __webpack_public_path__ + "static/column-img-3-62b94ebb4f8437f4d3d267860c1446d0.jpg";